export default "__VITE_ASSET__2UZbO0Lm__"